// mobileSize = 800;

$(document).ready(function(){
  // Check Window Size
  // const windowSize = $(window).width();

  // if (windowSize < 800) {
  //   $('body')
  //     .addClass('saffireMobileSize')
  //     .removeClass('saffireLargeSize');
  // } if (windowSize > 801) {
  //   $('body').removeClass('saffireMobileSize');
  // }
  
  // General Message
  $('.generalmessage').prependTo('header');

  $('.header .standAloneDirections').html('<span>Hours & </span><span>Directions</span>');

  $('.header .searchBox .inputFieldTextbox').attr('placeholder', 'Search Website');

});

$(window).load(function(){
	// $('body').addClass('pageIsLoaded');

    let starObserver = new IntersectionObserver(
      (entries, observer) => { 
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            $('.footer-bottom').addClass('showing');
          }
        });
      }, 
      {threshold: 0.75});
  
  
      document.querySelectorAll('.footer-bottom').forEach(el => { starObserver.observe(el) });



});